import { observer } from "mobx-react-lite";

import { Nav } from "@ui-components/navigation/Nav.tsx";

import { useNavLinks } from "./hooks/useNavLinks.ts";

export const CollapsedMenu = observer(() => {
  const navLinks = useNavLinks();

  return (
    <Nav
      renderAsButton
      buttonProps={{ text: "Menu", hideChevron: true }}
      links={navLinks}
    />
  );
});
